export default __webpack_public_path__ + "b80ab6c385488458878d47239a239184.png";